module.exports = __webpack_public_path__ + "img/dialog_bg02.748f5944.png";